import { useQuery } from '@tanstack/react-query'

import { IBranch } from '@/models'

import { QUERY_KEY_BRANCHES } from '../../types/constants'
import { authenticatedApi } from '../../utils/api'

async function getBranches({
  includeInactive,
  filterMissingZipZones,
}: {
  includeInactive?: boolean
  filterMissingZipZones?: boolean
}) {
  if (includeInactive) {
    return authenticatedApi
      .get('branch', {
        searchParams: {
          includeInactive,
        },
      })
      .json<IBranch[]>()
  }
  if (filterMissingZipZones) {
    return authenticatedApi
      .get('branch', {
        searchParams: {
          filterMissingZipZones,
        },
      })
      .json<IBranch[]>()
  }

  return authenticatedApi.get('branch').json<IBranch[]>()
}

export const useBranches = ({
  includeInactive,
  filterMissingZipZones,
  freezeCache,
}: { includeInactive?: boolean; filterMissingZipZones?: boolean; freezeCache?: boolean } = {}) => {
  return useQuery({
    queryKey: [QUERY_KEY_BRANCHES, includeInactive, filterMissingZipZones],
    queryFn: () => getBranches({ includeInactive, filterMissingZipZones }),
    staleTime: freezeCache ? Infinity : 10 * 60 * 1000, // 10 minutes - branches rarely change
    refetchOnWindowFocus: false,
    refetchOnMount: freezeCache ? false : undefined,
    refetchOnReconnect: freezeCache ? false : undefined,
  })
}
